import script from "./KanbanBoardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanBoardHeader.vue?vue&type=script&setup=true&lang=js"

import "./KanbanBoardHeader.vue?vue&type=style&index=0&id=006682f0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006682f0"]])

export default __exports__